<template>
<div class>
    <div class="clearfix">
        <div class="wl-certification-content">
            <div class="authen-hade-title clearfix">
                <h3 class="h3-text-title">
                    <span>标准建设</span>
                </h3>
                <div class="authen-hade-crumbs">
                    <i class="wl-icon-zhuye1"></i>
                    <span>当前位置：</span>
                    <span @click="goHome">网站首页</span>
                    <span>></span>
                    <span>标准建设</span>
                </div>
            </div>
            <div class="border-class-content">
                <div class="lecturer-certi-standard">
                    <h3 class="h3-wl-title">
                        <span class="sp-title-text">{{certifyName}}</span>
                    </h3>
                </div>
                <div class="standard-build-content" v-if="fileList.length > 0">
                    <p class="clearfix p-down-file-con" v-for="item in fileList" :key="item.id">
                        <i class="wl-icon-dian"></i>
                        <a :href="item.downloadUrl" target="_blank" :download="item.docTitle">{{item.docTitle}}</a>
                        <a class="fr" :href="item.downloadUrl" :download="item.docTitle">点击下载</a>
                    </p>
                </div>
                <div v-else class="no-data-tip-con">
                    <img :src="nodataImg" alt="">
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            isTab: 1,
            back: require("assets/images/bg-jieshao.png"),
            TeaAuthenticaList: [],
            certifyIdValue: '',
            fileList: [],
            certifycateList: [],
            certifyName: '',
            cerfityIdValue: '',
            nodataImg: require("assets/images/the-last-new-nodata-imag.png"),
        };
    },
    props: {
        certifyId: {
            type: String,
            default: ''
        }
    },
    watch: {
        certifyId(val) {
            this.cerfityIdValue = val;
            this.getStandardList(val);
        }
    },
    created() {
        this.cerfityIdValue = this.certifyId;
        this.getStandardList();
        this.getCerfitycateList();
    },
    methods: {
        goHome() {
            this.$router.push({
                name: "xHome"
            });
        },
        getStandardList() {
            this.$http.post("/api/XOrg/ProjectIntroduction/getStandardConstructionList", {
                certificateId: this.cerfityIdValue
            }).then(res => {
                if (res.code > 0) {
                    this.fileList = res.list;
                }
            });
        },
        getCerfitycateList() {
            this.$http.post("/api/XOrg/AssociationIndex/getCertificateList").then(res => {
                if (res.code > 0) {
                    this.certifycateList = res.list;
                    this.certifycateList.forEach(val => {
                        if (val.id == this.cerfityIdValue) {
                            this.certifyName = val.CertificateName;
                        }
                    });
                }
            });
        }
    }
};
</script>
